import { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import axios from 'axios';

import BackgroundImage from '../assets/images/about.jpg';

const NewsletterStatusPage = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const hasExecuted = useRef(new Set());
    const [timer, setTimer] = useState(5);

    useEffect(() => {
        const id = searchParams.get('id');
        const action = searchParams.get('action');

        if (!id || !action) {
            setStatus('error');
            return;
        }

        const uniqueKey = `${action}-${id}`;
        if (hasExecuted.current.has(uniqueKey)) {
            return;
        }
        hasExecuted.current.add(uniqueKey);

        let apiConfig;
        switch (action) {
            case 'unsubscribe':
                apiConfig = {
                    method: 'DELETE',
                    url: 'https://api.robinhoodboechout.be/api/v1/subscriber',
                    data: { confirmation_token: id },
                };
                break;
            case 'confirm':
                apiConfig = {
                    method: 'PATCH',
                    url: 'https://api.robinhoodboechout.be/api/v1/subscriber',
                    data: { confirmation_token: id, is_confirmed: true },
                };
                break;
            default:
                setStatus('error');
                return;
        }

        axios(apiConfig).then(() => setStatus('success')).catch(() => setStatus('error'));

    }, [searchParams]);

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prev => {
                if (prev > 1) return prev - 1;
                clearInterval(countdown);
                window.location.href = '/';
                return 0;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, []);

    return (
        <div className='flex flex-col items-center justify-center h-screen bg-gray-100 bg-center bg-cover'  style={{ backgroundImage: `url(${BackgroundImage})` }}>
            <div className='bg-[rgba(0,0,0,0.5)] w-full'>
            {status === 'loading' && <p className='text-gray-600'>Aanvraag aan het verwerken...</p>}
            {status === 'success' && (
                <>
                    {searchParams.get('action') === 'unsubscribe' && (
                        <>
                            <div className="flex flex-col items-center justify-center min-h-screen">
                                <div className="px-6 py-8 bg-white shadow-md rounded-2xl text-center">
                                    <FaTimesCircle className="mx-auto mb-4 text-red-500" size={64} />
                                    <h1 className="text-2xl font-semibold mb-2">U bent afgemeld!</h1>
                                    <p className="text-gray-600">U bent succesvol afgemeld voor onze nieuwsbrief. Als u van gedachten verandert, kunt u zich altijd opnieuw abonneren.</p>
                                    <p className="text-gray-600 italic pt-3">U wordt doorverwezen naar de hoofdpagina in {timer} seconden...</p>
                                </div>
                            </div>
                        </>
                    )}
                    {searchParams.get('action') === 'confirm' && (
                        <>
                            <div className="flex flex-col items-center justify-center min-h-screen">
                                <div className="px-6 py-8 bg-white shadow-md rounded-2xl text-center">
                                    <FaCheckCircle className="mx-auto mb-4 text-green-500" size={64} />
                                    <h1 className="text-2xl font-semibold mb-2">U bent geabonneerd!</h1>
                                    <p className="text-gray-600">Bedankt voor uw inschrijving op onze nieuwsbrief. Wij houden u op de hoogte van het laatste nieuws.</p>
                                    <p className="text-gray-600 italic pt-3">U wordt doorverwezen naar de hoofdpagina in {timer} seconden...</p>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
            {status === 'error' &&
                <>
                    <div className="flex flex-col items-center justify-center min-h-screen">
                        <div className="px-6 py-8 bg-white shadow-md rounded-2xl text-center">
                            <FaTimesCircle className="mx-auto mb-4 text-red-500" size={64} />
                            <h1 className="text-2xl font-semibold mb-2">Oops, er ging iets mis.</h1>
                            <p className="text-gray-600 italic pt-3">U wordt doorverwezen naar de hoofdpagina in {timer} seconden...</p>
                        </div>
                    </div>
                </>

            }
            </div>
        </div>
    );
};

export default NewsletterStatusPage;
